//Dependencies.
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { collection, deleteDoc, doc, getDocs, query, setDoc } from "firebase/firestore";
import { getDownloadURL } from "firebase/storage";
import { v4 } from "uuid";
import { auth, db } from "../databases/firebase";
import { uploadAndRetrieveFiles } from "../functions/firebase/storage";

const initialState = { loggedIn: {}, allUsers: {}, isLoading: false, message: "" };

export const addUserToDBThunk = createAsyncThunk(
   "allUsers/addToDB",
   async (payload, { dispatch, rejectWithValue }) => {

      try {
         //async logic to: (1) add uploaded image to Firebase Storage. (2) authenticate user with Firebase auth and (3) add user to Firebase Firestore.
         const _imageID = `_userID${payload._userID}_imageID${v4()}`;
         const desktopFile = payload.imageLink;
         const { name } = payload.imageLink;

         const uploadFile = await uploadAndRetrieveFiles(_imageID, desktopFile, "user");
         const imageLink = await getDownloadURL(uploadFile.ref);

         console.log({ fileName: 'allUsersSlice.js', from: 'addUserToDBThunk', uploadFile, message: `Successfully added ${JSON.stringify(uploadFile)} to Firebase storage.` });

         //Retrieve URL from Firebase Storage.

         return { ...payload, imageLink };
      } catch (err) {
         console.error({ origin: "addUserToDBThunk", err, errCode: err.code, errMessage: err.message, rejectWithValue: rejectWithValue("Reject with value Error.") });
      }
   }
)

export const authenticateAndAddUserToFS = createAsyncThunk(
   "allUsers/authenticateAndAddUserToFS",
   async (payload, { dispatch, rejectWithValue }) => {
      try {
         const authenticateUser = await createUserWithEmailAndPassword(auth, payload.email, payload.password);

         const _userID = authenticateUser.user.uid;
         payload = { ...payload, _userID };

         if (payload.imageSource === "computer") {
            const _imageID = `_userID${_userID}_imageID${v4()}`;
            const desktopFile = payload.imageLink;
            const { name } = payload.imageLink;
   
            const uploadFile = await uploadAndRetrieveFiles(_imageID, desktopFile, "user");
            const imageLink = await getDownloadURL(uploadFile.ref);
            payload = { ...payload, imageLink };
         } //Add image to Firebase storage if image is downloaded.

         const addUserToFS = await setDoc(doc(db, "internet-idol-faceoff", "Members", "allMembers", payload._userID), payload);

         const setCurrentUser = await setDoc(doc(db, "internet-idol-faceoff", "Members", "currentUser", payload._userID), payload);

         console.log({ FirestoreUser: addUserToFS, currentUser: setCurrentUser });

         await dispatch(signupAndAddNewUser({ ...payload }));
      } catch (err) {
         console.error({ origin: 'authenticateAndAddUserToFS', err, errCode: err.code, errMessage: err.message });
         rejectWithValue(`REJECT WITH VALUE ERROR!!! ${JSON.stringify(err)}`);
      }
   }
)

export const updateReduxWithFSUsersData = createAsyncThunk(
   "allUsers/udpateReduxWithFSUsersData",
   async (payload, { dispatch, rejectWithValue }) => {
      try {
         let currentUser = {};
         const allUsers = {};

         const loggedInUserQuery = query(collection(db, "internet-idol-faceoff", "Members", "currentUser"));
         const loggedInUserQuerySnapshot = await getDocs(loggedInUserQuery);
         loggedInUserQuerySnapshot.forEach(val => {
            console.log("=== Currently Logged In. ===");
            const loggedinuserdetails = val.data();
            currentUser = { ...loggedinuserdetails };
            console.log({ loggedinuserdetails_spreadOperator: { ...loggedinuserdetails }, currentUser, data: val.data() });
            console.log("============================");
         })

         const allMembersQuery = query(collection(db, "internet-idol-faceoff", "Members", "allMembers"));
         const allMembersQuerySnapshot = await getDocs(allMembersQuery);
         console.log("=== ALL MEMBERS. ===")
         allMembersQuerySnapshot.forEach(val => {
            console.log("value data: ", val.data());
            const memberdetails = val.data();
            allUsers[memberdetails._userID] = { ...memberdetails };
         });
         console.log("====================")

         return { currentUser, allUsers };
      } catch (err) {
         console.error({ origin: "updateReduxWithFSUsersData", err, errCode: err.code, errMessage: err.message });
         console.log(rejectWithValue('Reject with value error in updateReduxWithFSUsersData!!!'));
      }
   }
)

export const logUserOutFromFBandRedux = createAsyncThunk(
   "allUsers/logUserOutFS",
   async (payload, { dispatch, rejectWithValue }) => {
      try {
         //Order matters: (1)Sign out Redux. (2)Delete from FS. (3)sign out FB.
         const signOutRedux = await dispatch(logUserOut()); //First.
         const removeCurrentUserFromFS = await deleteDoc(doc(db, "internet-idol-faceoff", "Members", "currentUser", auth?.currentUser?.uid)); //Second.
         const signOutFB = await signOut(auth); //Third.
      } catch (err) {
         console.error({ origin: 'logUserOutFromFBandRedux', err, errMessage: err.message, errCode: err.code });
         rejectWithValue(`!!! Reject with value error upon logging user out !!! ${JSON.stringify(err)}.`);
      }
   }
)

export const removeUserFromDBThunk = createAsyncThunk(
   "allUsers/removeFromDB",
   async (payload, { dispatch, rejectWithValue }) => {
      try {
         //async logic here.
         return payload;
      } catch (err) {
         console.error({ origin: "removeUserFromDBThunk.", err, errCode: err.code, errMessage: err.message, rejectWithValue: rejectWithValue("Reject with value error.") });
      }
   }
)

export const loginThunk = createAsyncThunk(
   "allUsers/login",
   async (payload, { dispatch, rejectWithValue }) => {
      const { email, password, ...rest } = payload;

      try {
         const login = await signInWithEmailAndPassword(auth, email, password);
         const setCurrentUser = await setDoc(doc(db, "internet-idol-faceoff", "Members", "currentUser", payload._userID), payload);
         
         return { ...payload };
      } catch (err) {
         console.error({ origin: "loginThunk", err, errCode: err.code, errMessage: err.message, rejectWithValue: rejectWithValue("Reject with value error!!!") });
      }
   }
)

const allUsersSlice = createSlice({
   name: "allUsers",
   initialState,
   reducers: {
      signupAndAddNewUser: (state, { payload }) => {
         return { ...state, loggedIn: { ...payload }, allUsers: { ...state.allUsers, [payload._userID]: { ...payload } } };
      },
      logUserOut: state => {
         console.log("SUCCESS!!!")
         return { ...state, loggedIn: {} };
      },
      logUserIn: (state, { payload }) => {
         return { ...state, loggedIn: { ...payload } };
      }
   },
   extraReducers: {
      [addUserToDBThunk.pending]: state => {
         state.isLoading = true;
         state.message = "Please wait while we add user to DB.";
         console.log({ loading: state.isLoading, message: state.message });
      },
      [addUserToDBThunk.fulfilled]: (state, { payload }) => {
         state.isLoading = false;
         state.message = "";
         state.loggedIn = { ...payload };
         state.allUsers = { ...state.allUsers, [payload._userID]: { ...payload } };
      },
      [addUserToDBThunk.rejected]: (state, { payload, error }) => {
         state.isLoading = false;
         state.message = "";

         if (error) {
            console.error(error.message);
            console.error("Error loading user to DB. payload: ", payload);
         } else {
            console.error(`There seems to be an error loading user to DB. Payload is ${JSON.stringify(payload)}.`);
         }
      },
      [authenticateAndAddUserToFS.pending]: (state, { payload }) => {
         state.isLoading = true;
         state.message = `Please wait while we load ${JSON.stringify(payload)} to Firebase/Firestore.`
      },
      [authenticateAndAddUserToFS.fulfilled]: (state, { payload }) => {
         state.isLoading = false;
         state.message = "";
      },
      [authenticateAndAddUserToFS.rejected]: (state, { payload, rejectWithValue }) => {
         state.isLoading = false;
         state.message = "";
      },
      [loginThunk.pending]: state => {
         state.isLoading = true;
         state.message = "Please be patient while we log you in...";
         console.log({ isLoading: state.isLoading, message: state.message });
      },
      [loginThunk.fulfilled]: (state, { payload }) => {
         state.isLoading = false;
         state.message = "";
         state.loggedIn = { ...payload };
      },
      [loginThunk.rejected]: (state, { error, payload, rejectWithValue }) => {
         if (error || rejectWithValue) {
            console.error({ error, errorCode: error.code, errorMessage: error.message, rejectWithValue: rejectWithValue('Reject with value error inside loginThunk.rejected!!!', payload) });
         } else {
            console.error({ rejectWithValue: rejectWithValue("rejectWithValue inside loginThunk.rejected"), payload, message: "Something went wrong inside loginThunk.rejected!!!" });
         }
      },
      [logUserOutFromFBandRedux.pending]: state => {
         state.isLoading = true;
         state.message = "Please wait while we log the user out from Firebase and Redux...";
         console.log({ loadingStatus: state.isLoading, message: state.message });
      },
      [logUserOutFromFBandRedux.fulfilled]: state => {
         state.isLoading = false;
         state.message = "";
         console.log("===== SUCCESSFULLY LOGGED OUT!!! =====");
      },
      [updateReduxWithFSUsersData.pending]: state => {
         state.isLoading = true;
         state.message = 'Please be patient while we complete transfer of data from Firebase to Redux...';
         console.log({ loadingStatus: state.isLoading, messageStatus: state.message });
      },
      [updateReduxWithFSUsersData.fulfilled]: (state, { payload }) => {
         state.isLoading = false;
         state.message = ""
         console.log({ message: 'Successfully reached updateReduxWithFSUsersData.fulfilled!!!', payload });
         console.log({ state });
         const { currentUser, allUsers } = payload;
         console.log({ currentUser, allUsers, payload });
         state.loggedIn = { ...currentUser };
         state.allUsers = { ...allUsers };
      },
      [updateReduxWithFSUsersData.rejected]: (state, { error, rejectWithValue, payload }) => {
         state.isLoading = false;
         state.message = "";
         if (error || rejectWithValue) {
            console.log({ origin: 'updateReduxWithFSUsersData.rejected', error, errorCode: error.code, errorMessage: error.message, payload });
            console.error(rejectWithValue("Something went wrong trying to update FS Users Data (message from updateReduxWithFSUsersData.rejected)"));
         } else {
            console.error({ origin: updateReduxWithFSUsersData.rejected, message: "Something went wrong while trying to transfer data from Firebase to Redux", payload });
         }
      },
      [logUserOutFromFBandRedux.rejected]: (state, { error, rejectWithValue }) => {
         state.isLoading = false;
         state.message = "";
         if (error || rejectWithValue) {
            console.error({ origin: logUserOutFromFBandRedux.rejected, error, errorCode: error.code, errorMessage: error.message });
            rejectWithValue(`***** REJECT WITH VALUE ON LOGGING USER OUT!!! ***** ${JSON.stringify(error)}. `);
         }
      },
      [removeUserFromDBThunk.pending]: state => {
         state.isLoading = true;
         state.message = "Please wait while we remove user.";
      },
      [removeUserFromDBThunk.fulfilled]: (state, { payload }) => {
         state.loggedIn = {};
         state.message=""
         delete state.allUsers[payload._userID];
      },
      [removeUserFromDBThunk.rejected]: (state, { error, rejectWithValue }) => {
         state.loggedIn = {};
         state.message = "";
         if (error || rejectWithValue) {
            console.error({ error, errorCode: error.code, errorMessage: error.message });
            rejectWithValue(`Error removing user: ${JSON.stringify(error)}.`);
         } else {
            console.error("Something went wrong trying to remove the user.");
         }
      }
   }
});

export const { signupAndAddNewUser, logUserIn, logUserOut } = allUsersSlice.actions;
export const allUsersSliceReducer = allUsersSlice.reducer;

export const loggedInUser = state => state.allUsersSliceReducer.loggedIn;
export const allUsers = state => state.allUsersSliceReducer.allUsers;
export const allusersslicereducer = state => state.allUsersSliceReducer


